import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const TodayIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faStar} color="#F9D748" />;
};
